import { render } from "./ContactsPeopleBasicInfoEditor.vue?vue&type=template&id=334cec3a"
import script from "./ContactsPeopleBasicInfoEditor.vue?vue&type=script&lang=js"
export * from "./ContactsPeopleBasicInfoEditor.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__